import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Button,
    Typography,
} from '@mui/material';
import Select from 'react-select';
import AppNavbar from '../Navbar/AppNavbar';
import '../../assets/css/subscriptionTable.scss'
import Footer from '../Navbar/Footer';
import { Col, Row } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import profileImg from '../../assets/images/dashboard/profileImg.jpg'

const subscriptionData = [
    {
        customerName: 'Susan Walters',
        email: 'susanwalters.us@gmail.com',
        company: 'RightAway Technology',
        plan: 'Trail',
        totalCredits: 100,
        creditsUsed: 100,
        creditsLeft: 0,
        date: '08-11-2022',
        expiresIn: 'Expired'
    },
    {
        customerName: 'Yathish',
        email: 'wepwev@aol.com.pk',
        company: 'Salesmist',
        plan: 'Trail',
        totalCredits: 100,
        creditsUsed: 100,
        creditsLeft: 0,
        date: '14-11-2022',
        expiresIn: 'Expired'
    },
    {
        customerName: 'Sandra Brooks',
        email: 'sandra.brooks@prime-online-leads.com',
        company: 'Prime Digital Boosters',
        plan: 'Trail',
        totalCredits: 100,
        creditsUsed: 100,
        creditsLeft: 0,
        date: '25-11-2022',
        expiresIn: 'Expired'
    },
    {
        customerName: 'Mark',
        email: 'getfaststoreecom@gmail.com',
        company: 'Get Fast India',
        plan: 'Trail',
        totalCredits: 105,
        creditsUsed: 105,
        creditsLeft: 0,
        date: '16-10-2023',
        expiresIn: 'Expired'
    },
    {
        customerName: 'Bala U',
        email: 'bala.u@accops.com',
        company: 'Accops Systems Pvt. Ltd',
        plan: 'Trail',
        totalCredits: 100,
        creditsUsed: 100,
        creditsLeft: 0,
        date: '08-11-2023',
        expiresIn: 'Expired'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    },
    {
        customerName: 'CEO',
        email: 'ceo@lobotus.com',
        company: 'Lobotus',
        plan: 'Elite',
        totalCredits: 1000,
        creditsUsed: 152,
        creditsLeft: 848,
        date: '12-05-2025',
        expiresIn: '708 days.'
    }
    // Add more rows as needed
];

const AllSubscriptionTable = () => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleOpenModal = (row) => {
        setSelectedRow(row);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedRow(null);
    };
    return (
        <>
            <AppNavbar />
            <div className='page-content'>
                <Box className='subscription-table-container'>
                    <Typography variant="h6" gutterBottom className='subscription-table-header'>
                        Subscription
                    </Typography>

                    <Row className='m-0'>
                        <Col md={2}>
                            <Select />
                        </Col>
                        <Col md="auto" className='p-0'>
                            <Button variant="contained" color="primary">
                                Search
                            </Button>
                        </Col>
                    </Row>
                    <div className='p-3'>
                        <TableContainer component={Paper} className='subscription-table-div'>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ minWidth: 150 }}>Customer Name</TableCell>
                                        <TableCell>Email Id</TableCell>
                                        <TableCell sx={{ minWidth: 200 }}>Company</TableCell>
                                        <TableCell>Plan</TableCell>
                                        <TableCell sx={{ minWidth: 150 }}>Total Credits</TableCell>
                                        <TableCell sx={{ minWidth: 150 }}>Credits Used</TableCell>
                                        <TableCell sx={{ minWidth: 150 }}>Credits Left</TableCell>
                                        <TableCell sx={{ minWidth: 150 }}>Date</TableCell>
                                        <TableCell sx={{ minWidth: 150 }}>Expires In</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {subscriptionData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.customerName}</TableCell>
                                            <TableCell>{row.email}</TableCell>
                                            <TableCell>{row.company}</TableCell>
                                            <TableCell>{row.plan}</TableCell>
                                            <TableCell>{row.totalCredits}</TableCell>
                                            <TableCell>{row.creditsUsed}</TableCell>
                                            <TableCell>{row.creditsLeft}</TableCell>
                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>{row.expiresIn}</TableCell>
                                            <TableCell>
                                                <Button size="small" variant="outlined" onClick={() => handleOpenModal(row)}>View</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </Box>
            </div>

            {/* Modal */}
            <Modal show={openModal} onHide={handleCloseModal} centered className='subscription-detail-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRow && (
                        <>
                            <div className='subscription-detail-modal-first-div'>
                                <img
                                    src={profileImg}
                                    alt="Profile"
                                    style={{ height: "50px", width: '50px', borderRadius: '50%', marginRight: '10px' }}
                                />
                                <p><strong>{selectedRow.customerName}</strong></p>
                                <p className='email'>{selectedRow.email}</p>
                                <p>Admin</p>
                                <p>14707891088</p>
                            </div>
                            <div className='subscription-detail-modal-second-div'>
                                <div className='subscription-detail-modal-second-div'>
                                    <div className='subscription-detail-modal-second-first-div'>
                                        <div className="field-row">
                                            <span className="label">Company</span>
                                            <span className="colon">:</span>
                                            <span className="value">{selectedRow.company}</span>
                                        </div>
                                        <div className="field-row">
                                            <span className="label">Subscription Date</span>
                                            <span className="colon">:</span>
                                            <span className="value">{selectedRow.date}</span>
                                        </div>
                                        <div className="field-row">
                                            <span className="label">Credit Left</span>
                                            <span className="colon">:</span>
                                            <span className="value">{selectedRow.creditsLeft}</span>
                                        </div>
                                        <div className="field-row">
                                            <span className="label">Expires In</span>
                                            <span className="colon">:</span>
                                            <span className="value expired">{selectedRow.expiresIn}</span>
                                        </div>
                                    </div>

                                    <div className='subscription-detail-modal-second-first-div'>
                                        <div className="field-row">
                                            <span className="label">Current Plan</span>
                                            <span className="colon">:</span>
                                            <span className="value">{selectedRow.plan}</span>
                                        </div>
                                        <div className="field-row">
                                            <span className="label">Total Credits</span>
                                            <span className="colon">:</span>
                                            <span className="value">{selectedRow.totalCredits}</span>
                                        </div>
                                        <div className="field-row">
                                            <span className="label">Credits Used</span>
                                            <span className="colon">:</span>
                                            <span className="value">{selectedRow.creditsUsed}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" className="btn btn-primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Footer />
        </>
    );
};

export default AllSubscriptionTable;
